import { layout } from '../../App.routing'

export const indigenousAffairsSegment = layout.component({
    type: 'lima',
    props: {
        verticalSpacing: 'xl',
        fixedRatios: ['16:9'],
        cardOrientation: {
            type: 'Landscape-Portrait',
        },
        finalColumns: 4,
        intermediateColumns: 2,
        hasBackground: true,

        cardLayout: [
            ['teaserWithBackground'],
            ['teaserWithBackground'],
            ['teaserWithBackground'],
            ['teaserWithBackground'],
        ],
        dataDefinitionArgs: {
            type: 'curation',
            name: 'indigenous-affairs',
            offset: 0,
            pageSize: 8,
        },
        sectionHeader: {
            heading: 'Indigenous Affairs',
            headingUrl: '/news/indigenous-australians',
            section: undefined,
        },
    },
})
